import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { PaginationDefaults } from '../../../shared/utils/pagination-defaults.util';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { CampaignOverviewDto } from '../dtos/campaign-overview.dto';
import { CampaignOverviewModel } from '../models/campaign-overview.model';
import { CampaignsHeaderAndPaginationFilters } from '../store/slices/models/campaigns-header-and-pagination-filters.model';
import { mapCampaignOverviewDtoToCampaignOverviewModel } from '../utils/mapping/mapping.util';

export const getCampaigns: AsyncThunk<
  CampaignOverviewModel[],
  Partial<CampaignsHeaderAndPaginationFilters> | undefined,
  Record<string, unknown>
> = withMandant<
  Partial<CampaignsHeaderAndPaginationFilters> | undefined,
  CampaignOverviewModel[]
>(
  Endpoints.CAMPAIGNS_BY_MANDANT_ID,
  'campaigns/get-campaigns-with-pagination',

  async ({ args, endpoint }) => {
    const queryParams = createQueryParams({
      ...args?.header,
      size: args?.pagination?.size
        ? args.pagination.size
        : PaginationDefaults.size,
      offset: args?.pagination?.offset
        ? args.pagination.offset
        : PaginationDefaults.offset,
    });

    const { data }: AxiosResponse<CampaignOverviewDto[]> =
      await axiosInstance.get(endpoint + queryParams);

    return data.map(mapCampaignOverviewDtoToCampaignOverviewModel);
  }
);
